var option_webview_default = {
  "option": "jAR5Y",
  "user_choice": "CSpS-",
  "check": "_71GcN",
  "image": "_-3WdB",
  "input": "Wzh5a",
  "title": "pMXMQ",
  "centered": "J7-o0",
  "with_result": "Qm4UO",
  "list": "BxRHB",
  "with_image": "L-c8G",
  "progress": "YYvOF",
  "progress_value": "_-36HW",
  "label": "NZi7B",
  "cta": "_9ubh4",
  "adornment_icon": "_0ASNV",
  "remove": "_97QJ9",
  "removeButton": "hGnw6",
  "removeButtonIcon": "kQD9E",
  "overlay": "JyqLU",
  "shown": "Us5iB",
  "dark": "ocemw",
  "spinner": "cT9FY",
  "spin": "qyY4X",
  "grid": "QkwpR"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
